import './polyfills';
import { createGenerateClassName } from '@material-ui/core/styles'
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import JssProvider from 'react-jss/lib/JssProvider';
import {Provider} from "react-redux";
import Router from "./Components/Router/Router";
import store from "./ReduxRequests/Store/configureStore";
import './style/global.css';
import HelmetWrapper from './Components/HelmetWrapper/HelmetWrapper';

const generateClassName = createGenerateClassName({
    dangerouslyUseGlobalCSS: true
});

ReactDOM.render(
    <JssProvider generateClassName={generateClassName}>
        <Provider store={store}>
            <HelmetWrapper>
                <Router/>
            </HelmetWrapper>
        </Provider>
    </JssProvider>,
    document.getElementById('root') as HTMLElement
);



// WEBPACK FOOTER //
// ./src/index.tsx